import React, { useCallback, useEffect, useMemo, useState } from 'react';
import setUiMessage from '../../../Utilities/Tostify';
import { post } from '../../Auths/AuthToken';
import Select from 'react-select';
import Button from '../../Button';
import DatePickerCalander from '../../../Utilities/DatePickerCalander';
import CommonUploadFile from '../../../Utilities/CommonUploadFile';
import { format } from 'date-fns';
//import reportSchema from '../../../schema/reportSchema';
import { z } from 'zod';
import { isEmptyObject, zodErrorResolver } from '../../../Utilities/Utilities';
import AddPayorPopup from './AddPayorPopup';

function CredentialingPopup({ close, id = '', reload }) {
  const [allData, setAllData] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmit, setSubmit] = useState(false);

  const [payor, setPayor] = useState('');
  const [renProvider, setRenProvider] = useState('');
  const [appStatus, setAppStatus] = useState(0);
  const [submittedDate, setSubmittedDate] = useState(null);
  const [followUpDate, setFollowUpDate] = useState(null);
  const [appAttachment, setAppAttachment] = useState([]);
  const [appNote, setAppNote] = useState('');

  const [approvalDate, setApprovalDate] = useState(null);
  const [approvalAttachment, setApprovalAttachment] = useState('');
  const [approvalNote, setApprovalNote] = useState('');

  const [effectiveDate, setEffectiveDate] = useState(null);
  const [effectiveAttachment, setEffectiveAttachment] = useState('');
  const [effectiveNote, setEffectiveNote] = useState('');
  const [credentialId, setCredentialId] = useState('');
  const [rcmTicketId, setRcmTicketId] = useState('');

  const [ediStatus, setEdiStatus] = useState('');
  const [ediNote, setEdiNote] = useState('');

  const [eraStatus, setEraStatus] = useState('');
  const [eraNote, setEraNote] = useState('');

  const [eftStatus, setEftStatus] = useState('');
  const [eftNote, setEftNote] = useState('');

  const [portalURL, setPortalURL] = useState('');
  const [portalStatus, setPortalStatus] = useState('');
  const [portalUserId, setPortalUserId] = useState('');
  const [portalNote, setPortalNote] = useState('');
  const [portalPass, setPortalPass] = useState('');
  const [addPayorOpen, setAddPayerOpen] = useState(false);

  const formScheema = useMemo(
    () =>
      z.object({
        payor: z.string().min(1, 'Payor is required'),
        renProvider: z.string().min(1, 'Rendering provider is required'),
      }),
    []
  );

  const handlePayorSave = useCallback((list, addedPayor) => {
    setAllData((prev) => ({
      ...prev,
      payerListArr: [...prev.payerListArr, list],
    }));
    setPayor({
      value: addedPayor?.value,
      label: addedPayor?.label,
    });
  }, []);

  const validateForm = useCallback(() => {
    //const mattrixSchema = reportSchema.credentialMatrixSchema();

    const validation = formScheema.safeParse({
      payor: payor?.id || '',
      renProvider: renProvider?.id || '',
      submittedDate: submittedDate ? format(submittedDate, 'yyyy-MM-dd') : '',
    });

    if (!validation.success) {
      return validation.error.issues;
    }
    return '';
  }, [payor, renProvider, submittedDate, formScheema]);

  useEffect(() => {
    if (isSubmit) {
      const validationError = validateForm();
      if (!validationError) {
        setErrors({});
      } else {
        setErrors(zodErrorResolver(validationError));
      }
    }
  }, [isSubmit, validateForm]);

  useEffect(() => {
    try {
      const fetchData = async () => {
        const response = await post(
          'api/reports/managePayerMatrix/openPayerMatrixPopup',
          {
            id: id,
          }
        );

        if (response.status === 200) {
          setAllData(response.data);
          if (Number(id) > 0) {
            setPayor(
              response.data.payerListArr.filter(
                (item) =>
                  Number(item.id) ===
                    Number(response.data.matrixDetail.payer_id) && {
                    value: item.id,
                    label: item.name,
                  }
              )[0]
            );

            setRenProvider(
              response.data.billProvArr.filter(
                (item) =>
                  item.id === response.data.matrixDetail.renPro_id && {
                    value: item.id,
                    label: item.name,
                  }
              )[0]
            );

            setAppStatus(
              response.data.appStatusArr.filter(
                (item) =>
                  item.value ===
                    response.data.matrixDetail.application_status && {
                    value: item.id,
                    label: item.name,
                  }
              )[0]
            );
            setSubmittedDate(
              response.data.matrixDetail.application_submit_date &&
                response.data.matrixDetail.application_submit_date !==
                  '0000-00-00'
                ? new Date(response.data.matrixDetail.application_submit_date)
                : null
            );
            setFollowUpDate(
              response.data.matrixDetail.application_followup_date &&
                response.data.matrixDetail.application_followup_date !==
                  '0000-00-00'
                ? new Date(response.data.matrixDetail.application_followup_date)
                : null
            );

            setAppAttachment(response.data.payerAttachArr);
            setAppNote(response.data.matrixDetail.application_note);

            setApprovalDate(
              response.data.matrixDetail.approval_date &&
                response.data.matrixDetail.approval_date !== '0000-00-00'
                ? new Date(response.data.matrixDetail.approval_date)
                : null
            );
            setApprovalAttachment(response.data.approvalAttachArr);
            setApprovalNote(response.data.matrixDetail.approval_note);

            setEffectiveDate(
              response.data.matrixDetail.effective_date &&
                response.data.matrixDetail.effective_date !== '0000-00-00'
                ? new Date(response.data.matrixDetail.effective_date)
                : null
            );
            setEffectiveAttachment(response.data.effectiveAttachArr);
            setEffectiveNote(response.data.matrixDetail.effective_note);
            setCredentialId(response.data.matrixDetail.credential_id);
            setRcmTicketId(response.data.matrixDetail.rcm_id);

            setEdiStatus(
              response.data.statusArr.filter(
                (item) =>
                  item.value === response.data.matrixDetail.edi_status && {
                    value: item.value,
                    label: item.label,
                  }
              )[0]
            );
            setEdiNote(response.data.matrixDetail.edi_note);

            setEraStatus(
              response.data.statusArr.filter(
                (item) =>
                  item.value === response.data.matrixDetail.era_status && {
                    value: item.value,
                    label: item.label,
                  }
              )[0]
            );
            setEraNote(response.data.matrixDetail.era_note);

            setEftStatus(
              response.data.statusArr.filter(
                (item) =>
                  item.value === response.data.matrixDetail.eft_status && {
                    value: item.value,
                    label: item.label,
                  }
              )[0]
            );
            setEftNote(response.data.matrixDetail.eft_note);

            setPortalURL(response.data.matrixDetail.payer_portal_url);
            setPortalStatus(
              response.data.statusArr.filter(
                (item) =>
                  item.value ===
                    response.data.matrixDetail.payer_portal_status && {
                    value: item.value,
                    label: item.label,
                  }
              )[0]
            );
            setPortalUserId(response.data.matrixDetail.payer_portal_user);
            setPortalNote(response.data.matrixDetail.payer_portal_note);
            setPortalPass(response.data.matrixDetail.payer_portal_pass);
          }
        }
      };
      fetchData();
    } catch (error) {
      setUiMessage('err', error);
    }
  }, [id]);

  async function handleSaveMattrix() {
    try {
      setSubmit(true);

      // Validation
      const validationError = validateForm();
      if (validationError) {
        setErrors(zodErrorResolver(validationError)); // Display validation errors
        return;
      }

      // API Call
      const response = await post(
        'api/reports/managePayerMatrix/savePayerMatrix',
        {
          payerMatrixId: id,
          paymentPayer: payor?.value || '',
          payerRenderingProvider: renProvider?.id || '',
          applicationStatus: appStatus?.value || '',
          appSubmitDate: submittedDate
            ? format(submittedDate, 'yyyy-MM-dd')
            : '',
          appFollowupDate: followUpDate
            ? format(followUpDate, 'yyyy-MM-dd')
            : '',
          allApplicationAttach: appAttachment,
          appNote: appNote,
          approvalDate: approvalDate ? format(approvalDate, 'yyyy-MM-dd') : '',
          allApprovalAttach: approvalAttachment,
          approvalNote: approvalNote,
          effectiveDate: effectiveDate
            ? format(effectiveDate, 'yyyy-MM-dd')
            : '',
          allEffectiveAttach: effectiveAttachment,
          effectiveNote: effectiveNote,
          credentialId,
          rcmTicketId,
          ediStatus: ediStatus?.value || '',
          ediNote,
          eraStatus: eraStatus?.value || '',
          eraNote,
          eftStatus: eftStatus?.value || '',
          eftNote,
          portalURL,
          portalStatus: portalStatus?.value || '',
          portalUserId,
          portalNote,
          portalPass,
        }
      );

      if (response.status === 200) {
        setUiMessage('suc', 'Data saved successfully');
        reload();
        close();
      } else {
        throw new Error(response.message || 'Unexpected API response');
      }
    } catch (error) {
      console.error('Error in handleSaveMattrix:', error);
      setUiMessage('err', error.message || 'An error occurred');
    }
  }

  return (
    <div
      id="payerMatrixPopup"
      className="qadditionl-edit-main-con modalBackground"
    >
      <div className="bill-view-sectn-blk">
        <div className="view-sectn-blk ">
          <span className="clear-left10">
            Payer Provider Matrix:{allData?.headerDetail || ''}
          </span>
          <Button variant="circle" onClick={close}>
            X
          </Button>
        </div>
        <div className="width100 pymnt-popup-inner-body">
          <fieldset>
            <legend>Payor Credentialing</legend>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val">
                <div className="post-pymnt-lbl">
                  Payer name:<span className="required">*</span>
                </div>
                <div>
                  <div className="post-pymnt-val">
                    <Select
                      value={payor}
                      options={allData?.payerListArr}
                      onChange={(option) => setPayor(option)}
                      className="react-select-container"
                      classNamePrefix="react-select"
                    />
                    <Button
                      variant="primary"
                      style={{
                        marginLeft: '5px',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        padding: '5px 10px',
                      }}
                      onClick={() => setAddPayerOpen(true)}
                    >
                      +
                    </Button>
                  </div>
                  {errors?.payor && (
                    <p className="error">{errors?.payor?.message}</p>
                  )}
                </div>
              </div>
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Application Status:</span>
                <span className="post-pymnt-val">
                  <Select
                    value={appStatus}
                    options={allData?.appStatusArr}
                    onChange={(option) => setAppStatus(option)}
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </span>
              </div>
            </div>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">
                  Rendering provider:<span className="required">*</span>
                </span>
                <span className="post-pymnt-val">
                  <div>
                    <Select
                      value={renProvider}
                      options={allData?.billProvArr}
                      onChange={(option) => setRenProvider(option)}
                      className="react-select-container"
                      classNamePrefix="react-select"
                    />
                    {errors?.renProvider && (
                      <p className="error">{errors?.renProvider?.message}</p>
                    )}
                  </div>
                </span>
              </div>
              <div className="post-pymnt-rw-val">
                <div
                  className="flex-sec"
                  style={{
                    gap: '25px',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <span className="post-pymnt-lbl">Submitted:</span>
                  <span className="post-pymnt-val">
                    <div>
                      <DatePickerCalander
                        selectedDate={submittedDate}
                        setSelectedDate={(e) => setSubmittedDate(e)}
                      />
                      {errors?.submittedDate && (
                        <p className="error">
                          {errors?.submittedDate?.message}
                        </p>
                      )}
                    </div>
                  </span>
                </div>
                <div
                  className="flex-sec"
                  style={{
                    gap: '10px',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <span className="post-pymnt-lbl">Follow-up:</span>
                  <span className="post-pymnt-val">
                    <DatePickerCalander
                      selectedDate={followUpDate}
                      setSelectedDate={(e) => setFollowUpDate(e)}
                    />
                  </span>
                </div>
              </div>
            </div>
            <div className="post-pymnt-rw">
              <div className="" style={{ display: 'flex', width: '100%' }}>
                <span className="post-pymnt-lbl">Attachment:</span>
                <CommonUploadFile
                  key={allData?.payerAttachArr?.length}
                  apiUri="api/reports/managePayerMatrix/uploadDocument"
                  uploadBtn
                  buttonStyle={{ padding: '5px 10px' }}
                  fileUploadWraper={{ width: '92%' }}
                  handleUploadFile={(files) => setAppAttachment(files)}
                  selectedFiles={allData?.payerAttachArr}
                />
              </div>
            </div>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val width100">
                <span className="post-pymnt-lbl">Note:</span>
                <textarea
                  name="appNote"
                  value={appNote}
                  className="post-nt-txt white-bg"
                  placeholder="Write here..."
                  onChange={(e) => setAppNote(e.target.value)}
                ></textarea>
              </div>
            </div>
            <div className="dash-schedule-sep-dotted">&nbsp;</div>
            <div className="width100 qmed-common-bg">
              <div className="post-pymnt-rw">
                <div className="post-pymnt-rw-val">
                  <span className="post-pymnt-lbl">Approval:</span>
                  <span className="post-pymnt-val-calander">
                    <DatePickerCalander
                      selectedDate={approvalDate}
                      setSelectedDate={(e) => setApprovalDate(e)}
                    />
                  </span>
                </div>
              </div>
              <div className="post-pymnt-rw">
                <div className="pmsPopupinnerBodyrow post-pymnt-val">
                  <div className="" style={{ display: 'flex', width: '100%' }}>
                    <span className="post-pymnt-lbl">Attachment:</span>
                    <CommonUploadFile
                      key={allData?.approvalAttachArr?.length}
                      apiUri="api/reports/managePayerMatrix/uploadDocument"
                      uploadBtn
                      buttonStyle={{ padding: '5px 10px' }}
                      fileUploadWraper={{ width: '92%' }}
                      handleUploadFile={(files) => setApprovalAttachment(files)}
                      selectedFiles={allData?.approvalAttachArr}
                    />
                  </div>
                </div>
              </div>
              <div className="post-pymnt-rw">
                <div className="post-pymnt-rw-val width100">
                  <span className="post-pymnt-lbl">Note:</span>
                  <span className="post-pymnt-val">
                    <textarea
                      value={approvalNote}
                      name="approvalNote"
                      className="post-nt-txt white-bg"
                      placeholder="Write here..."
                      onChange={(e) => setApprovalNote(e.target.value)}
                    ></textarea>
                  </span>
                </div>
              </div>
            </div>
            <div className="dash-schedule-sep-dotted">&nbsp;</div>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Effective:</span>
                <span className="post-pymnt-val-calander">
                  <DatePickerCalander
                    selectedDate={effectiveDate}
                    setSelectedDate={(e) => setEffectiveDate(e)}
                  />
                </span>
              </div>
            </div>
            <div className="post-pymnt-rw">
              <div className="pmsPopupinnerBodyrow post-pymnt-val">
                <div className="" style={{ display: 'flex', width: '100%' }}>
                  <span className="post-pymnt-lbl">Attachment:</span>
                  <CommonUploadFile
                    key={allData?.effectiveAttachArr?.length}
                    apiUri="api/reports/managePayerMatrix/uploadDocument"
                    uploadBtn
                    buttonStyle={{ padding: '5px 10px' }}
                    fileUploadWraper={{ width: '92%' }}
                    handleUploadFile={(files) => setEffectiveAttachment(files)}
                    selectedFiles={allData?.effectiveAttachArr}
                  />
                </div>
              </div>
            </div>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val width100">
                <span className="post-pymnt-lbl">Note:</span>
                <span className="post-pymnt-val">
                  <textarea
                    value={effectiveNote}
                    name="effectiveNote"
                    className="post-nt-txt white-bg"
                    placeholder="Write here..."
                    onChange={(e) => setEffectiveNote(e.target.value)}
                  ></textarea>
                </span>
              </div>
            </div>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">ID:</span>
                <span className="post-pymnt-val">
                  <input
                    className="prtl-url-inpt"
                    type="text"
                    id="credentialId"
                    name="credentialId"
                    value={credentialId}
                    onChange={(e) => setCredentialId(e.target.value)}
                  />
                </span>
              </div>
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">RCM Ticket Id:</span>
                <span className="post-pymnt-val">
                  <input
                    className="prtl-url-inpt"
                    type="text"
                    id="rcmTicketId"
                    name="rcmTicketId"
                    value={rcmTicketId}
                    onChange={(e) => setRcmTicketId(e.target.value)}
                  />
                </span>
              </div>
            </div>
          </fieldset>
          <fieldset>
            <legend>EDI:</legend>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Status:</span>
                <span className="post-pymnt-val">
                  <Select
                    value={ediStatus}
                    options={allData?.statusArr}
                    onChange={(e) => setEdiStatus(e)}
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </span>
              </div>
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Note:</span>
                <span className="post-pymnt-val">
                  <textarea
                    value={ediNote}
                    id="ediNote"
                    name="ediNote"
                    className="post-nt-txt white-bg"
                    placeholder="Write here..."
                    onChange={(e) => setEdiNote(e.target.value)}
                  ></textarea>
                </span>
              </div>
            </div>
          </fieldset>
          <fieldset>
            <legend>ERA:</legend>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Status:</span>
                <span className="post-pymnt-val">
                  <Select
                    value={eraStatus}
                    options={allData?.statusArr}
                    onChange={(e) => setEraStatus(e)}
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </span>
              </div>
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Note:</span>
                <span className="post-pymnt-val">
                  <textarea
                    value={eraNote}
                    id="eraNote"
                    name="eraNote"
                    className="post-nt-txt white-bg"
                    placeholder="Write here..."
                    onChange={(e) => setEraNote(e.target.value)}
                  ></textarea>
                </span>
              </div>
            </div>
          </fieldset>
          <fieldset>
            <legend>EFT:</legend>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Status:</span>
                <span className="post-pymnt-val">
                  <Select
                    value={eftStatus}
                    options={allData?.statusArr}
                    onChange={(e) => setEftStatus(e)}
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </span>
              </div>
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Note:</span>
                <span className="post-pymnt-val">
                  <textarea
                    value={eftNote}
                    id="eftNote"
                    name="eftNote"
                    className="post-nt-txt white-bg"
                    placeholder="Write here..."
                    onChange={(e) => setEftNote(e.target.value)}
                  ></textarea>
                </span>
              </div>
            </div>
          </fieldset>
          <fieldset>
            <legend>Portal:</legend>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">URL:</span>
                <span className="post-pymnt-val">
                  <input
                    type="url"
                    id="portalURL"
                    name="portalURL"
                    className="prtl-url-inpt"
                    value={portalURL}
                    onChange={(e) => setPortalURL(e.target.value)}
                  />
                </span>
              </div>
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Status:</span>
                <span className="post-pymnt-val">
                  <Select
                    value={portalStatus}
                    options={allData?.statusArr}
                    onChange={(e) => setPortalStatus(e)}
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </span>
              </div>
            </div>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">User:</span>
                <span className="post-nt-val">
                  <input
                    type="text"
                    id="portalUserId"
                    name="portalUserId"
                    className="prtl-url-inpt"
                    value={portalUserId}
                    onChange={(e) => setPortalUserId(e.target.value)}
                  />
                </span>
              </div>
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Note:</span>
                <span className="post-pymnt-val">
                  <textarea
                    id="portalNote"
                    name="portalNote"
                    className="post-nt-txt white-bg"
                    placeholder="Write here..."
                    value={portalNote}
                    onChange={(e) => setPortalNote(e.target.value)}
                  ></textarea>
                </span>
              </div>
            </div>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Pass:</span>
                <span className="post-nt-val">
                  <input
                    type="password"
                    id="portalPass"
                    name="portalPass"
                    className="prtl-url-inpt"
                    value={portalPass}
                    onChange={(e) => setPortalPass(e.target.value)}
                  />
                </span>
              </div>
            </div>
          </fieldset>
        </div>
        <div className="bill-claim-edit-btn-rw">
          <Button
            variant="outline"
            onClick={close}
            style={{ padding: '5px 10px', marginRight: '10px' }}
          >
            Cancel
          </Button>

          <Button
            variant={!isEmptyObject(errors) ? 'default' : 'primary'}
            onClick={() => handleSaveMattrix()}
            style={{ padding: '5px 10px' }}
            disabled={!isEmptyObject(errors)}
          >
            {id !== '' ? 'Update' : 'Save'}
          </Button>
        </div>
      </div>
      {addPayorOpen && (
        <AddPayorPopup
          close={() => setAddPayerOpen(false)}
          handlePayorSave={handlePayorSave}
        />
      )}
    </div>
  );
}

export default CredentialingPopup;
